
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workingolf/reregister",
      function () {
        return require("private-next-pages/workingolf/reregister.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workingolf/reregister"])
      });
    }
  